import { render, staticRenderFns } from "./Bbcaidan.vue?vue&type=template&id=f2aa3528&scoped=true"
import script from "./Bbcaidan.vue?vue&type=script&lang=js"
export * from "./Bbcaidan.vue?vue&type=script&lang=js"
import style0 from "./Bbcaidan.vue?vue&type=style&index=0&id=f2aa3528&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2aa3528",
  null
  
)

export default component.exports